import { Button, Table, Modal, Form, Space, Select, SelectProps, Alert, Tag, Skeleton, Spin, Radio, Input, Tabs, Image, Dropdown, Badge, Avatar, MenuProps, message } from 'antd';
import TextArea from 'antd/es/input/TextArea';
import axios from 'axios';
import React, { useEffect, useState } from 'react'
import { Card, Col, Row } from 'react-bootstrap';
import { notify_success, toastStyle } from '../pages/UsersPage';
import { RequiredMark } from 'antd/es/form/Form';
import { CheckCircleOutlined, CloseOutlined, DownOutlined, EditFilled, FileExcelOutlined, InfoCircleOutlined, LinkOutlined, LogoutOutlined, SaveOutlined, SearchOutlined, UserOutlined } from '@ant-design/icons';
import { useDispatch } from 'react-redux';
import { useSelector } from 'react-redux';
import { listFacts } from '../actions/factsActions';
import { selectUserDetails } from '../features/auth/authSlice';
import * as XLSX from 'xlsx';
import { API_URL, AUTH_URL, DATA_URL } from '../constants';
import { TfiReload } from 'react-icons/tfi';
import { notify } from '../pages/LoginPage';
import { IBranch } from './UsersTable';
import { DatePicker } from 'antd';
import moment, { Moment } from 'moment';
import dayjs, { Dayjs } from 'dayjs';
import { IClient, ILoan, ILoanDetails } from '../factory/interfaces';
import TabPane from 'antd/es/tabs/TabPane';
import { PiAddressBookLight } from 'react-icons/pi';
import { MdBroadcastOnPersonal, MdOutlinePersonOutline, MdWorkOutline } from 'react-icons/md';
import { IoIosPerson, IoMdArrowDropright } from 'react-icons/io'
import { CiEdit, CiFilter } from "react-icons/ci"
import { FaFilter } from 'react-icons/fa6';
import { fetchLoans } from '../actions/loansActions';
import { IoPersonCircleOutline } from 'react-icons/io5'
import { RxCross2 } from "react-icons/rx"

const { RangePicker } = DatePicker

const LoansTable = () => {
    const dispatch = useDispatch()

    //variable/states
    const [isModalOpen, setIsModalOpen] = useState(false);
    const [editable, setEditable] = useState(true);
    const [dateRange, setDateRange]= useState<string[]>(['2024-03-17', '2024-05-20'])
    const [selectedLoan, setSelectedLoan]= useState<string |undefined>()
    const [loanData, setLoanData]= useState<ILoanDetails>()
    const [loanLoaded, setLoanLoaded]= useState(false)
    const [editMode, setEditMode]= useState<boolean>(false)
    const [isSubmitting, setIsSubmitting] = useState(false)
    const momentArray: Moment[] = dateRange.map(date => moment(date))
    const [reloadComponent, setReloadComponent] = useState('no')
    const [marchedClient, setMarchedClient]= useState<string | null>()
    const [clients, setClients] = useState<SelectProps['options']>([])
    const [filterParam, setFilterParam] = useState<string>('ALL')
    const [isEditing, setIsEditing] = useState(false)
    const metadata = useSelector((state: any) => state.metadata)
    const [branch, setSelectedBranch] = useState<string>()
    const [branches, setBranches]= useState<IBranch[]>()
    const [branchName, setBranchName] = useState<string | undefined>()

  type EventValue<T> = T | null

  // Convert moment array to Dayjs array
  const dayjsArray: Dayjs[] = momentArray.map(date => dayjs(date.toDate()));
      const valueArray: [EventValue<Dayjs>, EventValue<Dayjs>] = [
    dayjsArray[0] || undefined,
    dayjsArray[1] || undefined,
  ];


   const user_details = useSelector(selectUserDetails)

    const fetched_loans = useSelector((state: any) => state.loans)

   const isAdmin = user_details?.role === 'admin'

  
    const [loans, setLoans] = useState<ILoan[]>()

    //Functions

    const handleRowClick = async (record: any) => {
       setSelectedLoan(record._id)
        const response = await axios.get(`${AUTH_URL}/finances/loans/${record._id}`)
        if(response.data.success){
            setLoanData(response.data.loan)
            setLoanLoaded(true)
            showModal()
        }
  }

 const columns = [
    {
    title: 'No.',
    dataIndex: 'count',
    width: 60,
    render: (text:any, record:any, index:any) => index + 1,
  },
  {
    title: 'Client',
    dataIndex: 'client',
    key: 'client',
    width: 200,
    fixed: 'left' as any,
  },

  {
    title: 'Borrowed',
    dataIndex: 'amount',
    key: 'amount',
    width: 140,
  },
  {
    title: 'Amount to pay',
    dataIndex: 'amount_to_pay',
    key: 'amount_to_pay',
    width: 140,
  },
  {
    title: 'Amount paid',
    dataIndex: 'amount_paid',
    key: 'amount_paid',
    width: 120,
  },
  {
    title: 'Balance',
    dataIndex: 'balance',
    key: 'balance',
    width: 100,
  },
  
  {
    title: 'Start date',
    dataIndex: 'loan_start_date',
    key: 'loan_start_date',
    width: 120,

  },
  {
    title: 'End date',
    dataIndex: 'loan_end_date',
    key: 'loan_end_date',
    width: 120,

   
  },
   {
    title: 'Payment Period',
    dataIndex: 'payment_period',
    key: 'payment_period',
    width: 100,
  },
   {
    title: 'Installment period',
    dataIndex: 'installment_period',
    key: 'installment_period',
    width: 120,

  },
  {
    title: 'Category',
    dataIndex: 'category',
    width: 100,
    key: 'category',
    render: (text: string, loan: ILoan)=> {
      return (
            <Tag style={{width: '100%', textAlign:'center'}} className='rounded-0' color={(loan.category === 'NEW') ? 'cyan' : 'magenta'} key={loan._id}>
              { (loan.category ? loan.category : '').toUpperCase()}
            </Tag>
      )

    }
  },
   {
    title: 'Status',
    dataIndex: 'cleared',
    key: 'cleared',
    fixed: 'right' as const,
    width: 100,
    render: (text: string, loan: ILoan)=> {
      return (
            <Tag style={{width: '100%', textAlign:'center'}} className='rounded-0' color={(loan.status === 'ACTIVE') ? 'blue' : (loan.status === 'PAID') ? 'green' : (loan.status === 'DUE') ? 'red': (loan.status === 'PENDING') ? 'magenta' : 'error'} key={loan._id}>
              { (loan.status ? loan.status : '').toUpperCase()}
            </Tag>
      )

    }
  },
     {
    title: 'Fined',
    dataIndex: 'fined',
    key: 'fined',
    fixed: 'right' as const,
    width: 90,
    render: (text: string, loan: ILoan)=> {
      return (
            <Tag style={{width: '100%', textAlign:'center'}} className='rounded-0' color={(loan.fined) ? 'red' : 'green'} key={loan._id}>
              { (loan.fined ? 'YES' : 'NO')}
            </Tag>
      )

    }
  },

  {
    title: 'Action',
    dataIndex: '',
    key: '_id',
    width: 100,
    fixed: 'right' as const,
    render: (text: string, record: any) => <a style={{color: '#1677ff'}} onClick={()=>handleRowClick(record)}>View</a>,
  },

]


  const clearUserData = ()=> setLoanData(undefined)
  const showModal = () => {
    setIsModalOpen(true);
  }

  const handleOk = () => {
    setIsModalOpen(false);
    clearUserData()
  };

  const handleCancel = () => {
    setIsModalOpen(false);
    clearUserData()
  }

  const handleIssueLoan = async()=>{
    setIsSubmitting(true)
    const response = await axios.patch(`${AUTH_URL}/finances/loans/issue/${loanData?._id}`, {withCredentials: true})
    setIsSubmitting(false)
    if(response.data.success){
      notify_success(response.data.message, toastStyle)
        dispatch(fetchLoans(filterParam, marchedClient, branch) as any)
        handleCancel()
    }else{
      notify(response.data.message, toastStyle)

    }
  }

   const exportToExcel = () => {
      const fileName = 'rpms_data.xlsx';
      const table = document.getElementById('rpms-data-table');
      const clonedTable = table?.cloneNode(true) as HTMLTableElement;
      const excludedColumnIndices = [7];
      clonedTable.querySelectorAll('tr').forEach(row => {
        excludedColumnIndices.forEach(index => {
          row.deleteCell(index);
        });
      });

      const worksheet = XLSX.utils.table_to_sheet(clonedTable);
      const workbook = XLSX.utils.book_new();
      XLSX.utils.book_append_sheet(workbook, worksheet, 'Sheet1');
      XLSX.writeFile(workbook, fileName);
    }

/////
/////

  useEffect(()=>{
    dispatch(fetchLoans(filterParam, marchedClient, branch) as any)
}, [filterParam, marchedClient, branch])

useEffect(() => {
    if (metadata?.data?.success) {
      setBranches(metadata.data.meta_data.branches)
    }
  }, [metadata])

  const searchClients = (value: string, callback: Function) => {
      axios.post(`${AUTH_URL}/clients/search`, {name: value}, {withCredentials: true})
          .then((response) => {
          const data = response.data.clients.map((client: IClient) => ({
              value: client._id,
              text: `${client.surname} ${client.given_name} (${client.phone})`,
          }))
          callback(data);
          })
          .catch((error) => {
          notify(`${error.message}`, toastStyle)
          callback([])
          })
      }
  
  const handleSearchClient = (newValue: string) => {
      searchClients(newValue, setClients)
    }


/////
/////

const itemsNew = [
    { key: "1", label: "ALL", value: 'ALL', onClick: () => setFilterParam('ALL') },
    { key: "2", label: "PAID", value: 'PAID', onClick: () => setFilterParam('PAID') },
    { key: "3", label: "ACTIVE", value: 'ACTIVE', onClick: () => setFilterParam('ACTIVE') },
    { key: "4", label: "PENDING", value: 'PENDING', onClick: () => setFilterParam('PENDING') },
    { key: "5", label: "DUE", value: 'DUE', onClick: () => setFilterParam('DUE') },
]

const filterColor = filterParam === 'PAID' ? "green" : filterParam === 'ACTIVE' ? "blue" : filterParam === 'PENDING' ? "magenta" : filterParam === 'DUE' ? 'red': '#00000073'

const items: MenuProps['items'] = branches?.map(branch => ({
    label: branch.name.toUpperCase(),
    key: branch._id,
  }))

 const onClick: MenuProps['onClick'] = ({ key }) => {
    const selected = branches?.find(branch => branch._id === key)
    if (selected) {
      setBranchName(selected.name)
      setSelectedBranch(key)
      message.info(`Selected branch: ${selected.name}`)
    }
  }

  return (
    <Row>

    <Row className=' justify-content-between align-items-center py-0 g-0'>
        <Col className='text-start py-2 d-flex justify content-start'>
            <h4 className='medium text-uppercase fw-bold' style={{color: '#052c65', fontSize: 16, marginRight: 20}}> <IoMdArrowDropright />Loans</h4>
            {
              isAdmin &&
              <Dropdown menu={{ items, onClick }}>
                <a onClick={(e) => e.preventDefault()}>
                  <Space className='text-uppercase'>
                    {branchName ? branchName: 'Select Branch'}
                    <DownOutlined />
                  </Space>
                </a>
              </Dropdown>
            }
        </Col>
         <Col className='text-end py-2' lg={8}>
         <Row className='d-flex justify-content-end'>
          <Col className='text-end d-flex justify-content-end'>

          
           
            <Button type='link' className='rounded-4 border' icon={<IoPersonCircleOutline />}> CLIENT FILTER

              <Select
                showSearch
                placeholder="Enter name, or phone of client to search"
                defaultActiveFirstOption={false}
                suffixIcon={null}
                filterOption={false}
                onSearch={handleSearchClient}
                notFoundContent={null}
                options={(clients || []).map((client) => ({
                  value: client.value,
                  label: client.text,
                }))}
                allowClear
                onChange={setMarchedClient}
                className='rounded-4 border-0'
                style={{
                  border: 'none',
                  outline: 'none',
                  boxShadow: 'none',
                  borderRight: '0'
                }}
              />
            </Button>

              
        
          <Dropdown
          menu={{
            items:itemsNew,
          }}
        >
          
            <Space className='link-primary pre-auto rounded-4 border mx-2 px-2'>
              <span className='text-uppercase'> <FaFilter className='mx-1' />STATUS FILTER:</span>
              <span className='fw-bold text-uppercase'> 
              <Tag
               bordered
               className='px-3 rounded-4'
               color={filterColor}
               >{filterParam}</Tag> 
               <Badge count={fetched_loans.data.count} overflowCount={999}>
                {/* <Avatar shape="square" size="large" /> */}
              </Badge>
               
               </span>

              {/* <DownOutlined /> */}
            </Space>
          
          </Dropdown>
            <Button style={{marginLeft: '0px'}} onClick={()=>dispatch(fetchLoans(filterParam, marchedClient, branch) as any)}  className='rounded-4' type="dashed"> <TfiReload/> <span className='mx-0 text-uppercase'>Reload</span></Button>

          </Col>
         
         </Row>

         </Col>
            
        </Row>
    
     {
      fetched_loans.data.loans ?
      <Table 
          className='rounded-0' 
          id='rpms-data-table' 
          bordered 
          dataSource={fetched_loans.data.loans} 
          columns={columns}
          tableLayout='fixed'
          style={{overflow: 'auto'}} 
       />
       :
       <Spin style={{paddingTop: 100}} tip="Loading data..." size="large">
        <div className="content" />
      </Spin>

     }
    

    {
      (loanData && loanLoaded) ?

      <>
      <Modal width={800} open={isModalOpen} onOk={handleOk} onCancel={handleCancel}
         centered
         footer={[
       
                      (isAdmin && !loanData.issued) && (<Button loading={isSubmitting} type='primary' className='rounded-0 text-uppercase' key="issue" onClick={handleIssueLoan}>
                      <CheckCircleOutlined />   {isSubmitting ? 'Issuing loan...' : 'Issue Loan'}
                      </Button>),
                      <Button  className='rounded-0 text-uppercase' key="cancel" onClick={handleCancel}>
                      <RxCross2 />   Exit
                      </Button>
                ]}
         >
         <Row>
         <Col md={4}>
         <p className='text-uppercase fw-bold' style={{fontSize: '18px'}}>Loan Details</p>
         </Col>
         <Col className='d-flex justify-content-start'>
         <p><span className='small text-uppercase fw-bold'>Issuance status: </span>{loanData.issued? <Tag className='small rounded-0' color='green'>ISSUED</Tag>: <Tag className='rounded-0' color='magenta'>PENDING</Tag>}</p>
         <p><span className='small text-uppercase fw-bold'>Payment Status: </span> <Tag className='small px-3 rounded-0' color={loanData.status === 'PENDING' ? 'magenta': loanData.status === 'ACTIVE' ? 'blue': loanData.status === 'DUE' ? 'red': loanData.status === 'PAID' ? 'green': 'orange' }>{loanData.status}</Tag></p>

         </Col>
         
         </Row>
         <Card className='p-2 rounded-0'>
         <Tabs defaultActiveKey='1'>
          <TabPane
            tab={
              <span>
                <IoIosPerson style={{marginRight: "5px"}}/>
                Loan Details
              </span>
            }
            key="1"
          >
          <Form
                layout="vertical"
                    >
                    <Row>
                    <Col>
                    <Form.Item 
                    label="Amount" 
                    name="amount"
                    initialValue={loanData.amount}
                    >
                        <Input readOnly
                         />
                    </Form.Item>
                    
                    </Col>
                    <Col>
                       
                    <Form.Item label="Default Clause"
                    name="default_clause_amount"
                    initialValue={loanData.default_clause_amount}
                    >
                        <Input readOnly 
                        
                        />
                    </Form.Item>
                    
                    </Col>
                    
                    </Row>
                    <Row>
                    <Col>
                    <Form.Item label="Security type"
                    name="security_type"
                    initialValue={loanData.security_type}
                    >
                        <Input readOnly
                          
                        />
                    </Form.Item>
                    
                    </Col>
                    <Col>
                     <Form.Item label="Security"
                    name="security"
                    initialValue={loanData.security}
                    >
                        <Input readOnly
                        />
                    </Form.Item>
                    
                    </Col>
                    
                    </Row>
                    <Row>
                    <Col>
                    <Form.Item 
                      label="Start date"
                      name="loan_start_date"
                      initialValue={loanData.loan_start_date}

                      >
                        <Input readOnly={!editMode}
                         />
                    </Form.Item>
                    
                    </Col>
                    <Col>
                    <Form.Item 
                    label="End date"
                    name="phone"
                    initialValue={loanData.loan_end_date}

                    >
                      <Input
                        readOnly={!editMode}
                         />
                    </Form.Item>
                    
                    </Col>
                    </Row>
                    <Row>
                
                    <Col>
                      <Form.Item label="Files">
                        <Button type="link" href={`${AUTH_URL}/documents/${loanData.file}`} target="_blank">
                         <LinkOutlined /> {loanData.file}
                        </Button>
                      </Form.Item>

                    </Col>
                      <Col>
                      <Form.Item 
                      label="Date of registration"
                      name="date_of_creation"
                      initialValue={loanData.date_of_creation}

                      >
                          <Input readOnly
                          />
                      </Form.Item>
                      
                      </Col>
                    </Row>
                   

                </Form>
            
          </TabPane>
          <TabPane
            tab={
              <span>
                <MdWorkOutline style={{marginRight: "5px"}} />
                Guarantors Information
              </span>
            }
            key="2"
          >
          <Row>
          
          {
            loanData.guarantors.map((guarantor, index, array)=>{
              return <>
              <Col>
              
              <Form
                layout="vertical"
                    >
                    <Form.Item 
                    label={`Guarantor ${index +1} name`}
                    name={`guarantor_${index + 1}_name`}
                    initialValue={guarantor.name}
                    >
                        <Input readOnly
                         />
                    </Form.Item>
                    <Form.Item 
                      label={`Guarantor ${index +1} phone`}
                      name={`guarantor_${index + 1}_phone`}
                      initialValue={guarantor.phone}
                    >
                        <Input readOnly
                        />
                    </Form.Item>
                    <Form.Item 
                      label={`Guarantor ${index +1} address`}
                      name={`guarantor_${index + 1}_address`}
                    initialValue={guarantor.address}

                    >
                        <Input readOnly
                         />
                    </Form.Item>
                    {/* <Form.Item 
                      label="Employer address"
                      rules={[{required: true, message: "Phone number is required!"}]}
                      name="employer_address"
                      initialValue={loanData.employer?.address}

                      >
                        <Input disabled={!editMode}
                          onChange={(e) =>
                                setLoanData((prevUserData: any) => ({
                                    ...prevUserData,
                                    phone: e.target.value,
                                }))
                            }
                         />
                    </Form.Item> */}
                </Form>
                </Col>
              
              </>
            })
          }
          </Row>
          
            
          </TabPane>

          {/* Address Tab */}
           <TabPane
            tab={
              <span>
                <IoIosPerson style={{marginRight: "5px"}}/>
                Client Details
              </span>
            }
            key="3"
          >
          <Form
                layout="vertical"
                    >
                    <Row>
                    <Col md={4}>
                    <Image src={`${AUTH_URL}/photos/clients/${loanData.client.photo}`}>
                    
                    </Image>
                    
                    </Col>
                    <Col>
                     <Row>
                    <Col>
                    <Form.Item 
                    label="Surname" 
                    rules={[{required: true, message: "Surname is required!"}]}
                    name="surname"
                    initialValue={loanData.client.surname}
                    >
                        <Input readOnly
                         />
                    </Form.Item>
                    
                    </Col>
                    <Col>
                       
                    <Form.Item label="Given name"
                    rules={[{required: true, message: "Other name is required!"}]}
                    name="given_name"
                    initialValue={loanData.client.given_name}
                    >
                        <Input  readOnly
                        />
                    </Form.Item>
                    
                    </Col>
                    
                    </Row>
                    <Row>
                    <Col>
                    <Form.Item label="ID type"
                    rules={[{required: true, message: "Other name is required!"}]}
                    name="id_type"
                    initialValue={loanData.client.id_type}
                    >
                        <Input readOnly
                        />
                    </Form.Item>
                    
                    </Col>
                    <Col>
                     <Form.Item label="ID Number"
                    rules={[{required: true, message: "Id number is required!"}]}
                    name="id_number"
                    initialValue={loanData.client.id_number}
                    >
                        <Input  readOnly
                        />
                    </Form.Item>
                    
                    </Col>
                    
                    </Row>
                    <Row>
                    <Col>
                    <Form.Item 
                      label="Gender"
                      rules={[{required: true, message: "Gender is required!"}]}
                      name="gender"
                      initialValue={loanData.client.gender}

                      >
                        <Input readOnly
                         />
                    </Form.Item>
                    
                    </Col>
                    <Col>
                    <Form.Item 
                      label="Branch"
                      rules={[{required: true, message: "Branch is required!"}]}
                      name="branch"
                      initialValue={loanData.client.branch}

                      >
                        <Input readOnly
                         />
                    </Form.Item>
                    
                    </Col>
                    </Row>
                    <Row>
                      {/* <Col>
                      <Form.Item 
                      label="Level of education"
                      rules={[{required: true, message: "Education level is required!"}]}
                      name="education_level"
                      initialValue={userData.education_level}

                      >
                          <Input disabled={!editMode} value={userEmail} 
                            onChange={(e) =>
                                  setUserData((prevUserData: any) => ({
                                      ...prevUserData,
                                      education_level: e.target.value,
                                  }))
                              }
                          />
                      </Form.Item>
                      
                      </Col>
                      <Col>
                        <Form.Item
                          label="Farmer group"
                          name="farmer_group"
                          rules={[{ required: true, message: "User must belong to a branch!" }]}
                          initialValue={userData.farmer_group ? userData.farmer_group : undefined}
                        >
                          <Select
                            allowClear
                            placeholder="Select farmer group name"
                            value={userPlant}
                            style={{ width: '100%' }}
                            options={plants?.map((plant) => ({
                              value: plant._id,
                              label: plant.name,
                            }))}
                            disabled={!editMode}
                            onChange={(value) =>
                                          setUserData((prevUserData: any) => ({
                                              ...prevUserData,
                                              plant: value,
                                          }))
                                      }
                          />
                        </Form.Item>
                      
                      </Col> */}
                    </Row>
                    <Row>
                      <Col>
                      <Form.Item 
                      label="Email address"
                      rules={[{required: true, message: "Email address is required!"}]}
                      name="email"
                      initialValue={loanData.client.email}

                      >
                          <Input readOnly
                          />
                      </Form.Item>
                      
                      </Col>
                      <Col>
                        <Form.Item
                          label="Phone number"
                          name="phone"
                          rules={[{ required: true, message: "User must belong to a branch!" }]}
                          initialValue={loanData.client.phone}
                        >
                          <Input readOnly
                          />
                      
                        </Form.Item>
                      
                      </Col>
                    </Row>
                    
                    </Col>
                    
                    </Row>

                </Form>
            
          </TabPane>
         
         </Tabs>
         
                
            </Card>
      </Modal>
      </>
      :
      <>
      
      </>
    }
    </Row>
  )
}

export default LoansTable